import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Per-tab impersonation: if sessionStorage.imp_token is set, ship it as a Bearer
// header on every request. This lets an admin open a brand's portal in a new tab
// without evicting their admin cookie.
authApi.interceptors.request.use((config) => {
  try {
    const imp = typeof window !== "undefined" && window.sessionStorage?.getItem("imp_token");
    if (imp) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${imp}` };
  } catch { /* noop */ }
  return config;
});

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startLogin = (target = "/pod-portal") => {
  const redirectUrl = window.location.origin + target;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const logout = async () => {
  try {
    await authApi.post("/auth/logout");
  } catch (e) {
    // ignore
  }
};

export const PLAN_LABELS = {
  none: "No Plan",
  basic: "Basic Wallet",
  growth: "Growth Wallet",
  scale: "Scale Wallet",
};
